import React from "react";
import { Box, IconButton } from "@mui/material";
import colors from "../../../shared/themes/colors";
import OverflowTooltip from "../../../shared/components/OverflowTooltip";
import PaperWithThreeStripsIcon from "../../../shared/assets/icons/PaperWithThreeStripsIcon";
import CloseIcon from "@mui/icons-material/Close";
import { ServiceReportFile } from "../models/ServiceReportsModel";
import DownloadIcon from "../../../shared/assets/icons/DownloadIcon";
import { formatFileSize } from "../../../shared/models/models";

interface ServiceReportFileProps {
  file: ServiceReportFile;
  fileIndex: number;
  onDelete?: (index: number) => void;
  canDelete?: boolean;
  canDownload?: boolean;
}

const ReportFile = ({ file, onDelete, canDelete = true, canDownload = true, fileIndex }: ServiceReportFileProps) => {

  const download = (file: ServiceReportFile) => {
    const link = document.createElement("a");
    link.href = file.content;
    link.target = "_blank";
    link.click();
    link.remove();
  };

  return (
    <Box
      className="flex justify-between items-center gap-2 w-full py-3 px-4"
      sx={{ background: colors.secondary.gray96, borderRadius: "4px" }}
    >
      <Box className="flex items-center gap-2">
        <PaperWithThreeStripsIcon />
        <Box sx={{ width: "110px" }}>
          <OverflowTooltip text={file.name} className="text-16-medium" color={"#333333"} />
        </Box>
      </Box>

      <Box className="flex gap-2 items-center">
        <Box className="text-16-medium" color="#7A8093">
          {formatFileSize(file.size)}
        </Box>

        {canDownload && (
          <IconButton onClick={() => download(file)}>
            <DownloadIcon />
          </IconButton>
        )}

        {canDelete && (
          <IconButton onClick={() => onDelete?.(fileIndex)}>
            <CloseIcon sx={{ color: colors.primary.red, fontSize: "16px" }} />
          </IconButton>
        )}
      </Box>
    </Box>
  );
};
export default ReportFile;